import { registerModal } from 'features/Modal/ModalRegistry'
import { ThreadCreateModal } from './ThreadCreateModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'THREAD_CREATE_MODAL'
registerModal(modalType, ThreadCreateModal)
export const showThreadCreateModal = () =>
  showModal({
    modalType,
    modalProps: {},
  })



// WEBPACK FOOTER //
// src/features/Messages/ThreadCreateModal/ThreadCreateModal.action.ts